var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSnow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M21.984 10.616v1.968h-4.176l3.24 3.24-1.416 1.44L15 12.584h-2.016V14.6l4.68 4.632-1.44 1.416-3.24-3.24v4.176h-1.968v-4.176l-3.24 3.24-1.44-1.416 4.68-4.632v-2.016H9l-4.632 4.68-1.416-1.44 3.24-3.24H2.016v-1.968h4.176l-3.24-3.24 1.416-1.44L9 10.616h2.016V8.6l-4.68-4.632 1.44-1.416 3.24 3.24V1.616h1.968v4.176l3.24-3.24 1.44 1.416-4.68 4.632v2.016H15l4.632-4.68 1.416 1.44-3.24 3.24z"
})));
export default SvgSnow;